import type { ReactNode, RefObject } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import "./ExportDialogFrame.css";

export function ExportDialogFrame({
  titleId,
  eyebrow,
  title,
  onClose,
  dialogRef,
  closeRef,
  closeDisabled = false,
  wide = false,
  overlayClassName = "",
  panelClassName = "",
  children,
}: {
  titleId: string;
  eyebrow: string;
  title: ReactNode;
  onClose: () => void;
  dialogRef: RefObject<HTMLDivElement | null>;
  closeRef?: RefObject<HTMLButtonElement | null>;
  closeDisabled?: boolean;
  wide?: boolean;
  overlayClassName?: string;
  panelClassName?: string;
  children: ReactNode;
}) {
  return createPortal(
    <div
      className={`export-dialog-overlay ${overlayClassName}`.trim()}
      onClick={onClose}
    >
      <div
        ref={dialogRef}
        className={`export-dialog-panel${wide ? " export-dialog-panel--wide" : ""} ${panelClassName}`.trim()}
        data-visual-treatment={wide ? undefined : "operational-sheet"}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        onClick={(event) => event.stopPropagation()}
      >
        <header className="export-dialog-header">
          <div>
            <span>{eyebrow}</span>
            <h2 id={titleId}>{title}</h2>
          </div>
          <button
            ref={closeRef}
            type="button"
            className="export-dialog-close"
            onClick={onClose}
            aria-label="Fechar"
            disabled={closeDisabled}
          >
            <X size={18} aria-hidden="true" />
          </button>
        </header>
        {children}
      </div>
    </div>,
    document.body,
  );
}
